import * as S from "./styles";

const Loading = () => {
  return <S.Rotate></S.Rotate>;
};

export default Loading;
